import { Badge, IconButton } from '@mui/material'
import { Icon, BellIcon } from '@design-systems/react-icons'
import { badgeSx } from '../styles/NotificationStyle'

export default function NotificationBell({ unreadCount, onClick }) {
  return (
    <IconButton
      onClick={onClick}
      sx={{
        color: 'inherit',
        padding: '8px',
      }}
      style={{
        color: 'white',
        padding: '8px',
      }}
    >
      <Badge
        badgeContent={unreadCount > 99 ? '99+' : unreadCount}
        sx={badgeSx(unreadCount)}
      >
        <Icon
          svg={BellIcon}
          size="lg"
          style={{
            color: 'white',
          }}
        />
      </Badge>
    </IconButton>
  )
}
